export default {
    general: {
        name: 'Ime',
        email: 'Email',
        description: 'Opis',
        status: 'Stanje',
        date: 'Datum',
        id: 'ID',
        size: 'Veličina',
        add: 'Dodaj',
        data: 'Podatki',
        more_info: 'Več informacij',
        all: 'Vsi',
        clear_filters: 'Počisti filtre',
        expand_columns: 'Razširi stolpce',
        filter_mode: 'Način filtra',
        filter_contains: 'Vsebuje',
        filter_not_contains: 'Ne vsebuje',
        filter_equals: 'Je enako',
        filter_not_equals: 'Ni enako',
        filter_starts_with: 'Se začne z',
        filter_ends_with: 'Se konča z',
        filter_less_than: 'Manjše kot',
        filter_less_than_or_equal: 'Manjše ali enako',
        filter_greater_than: 'Večje kot',
        filter_greater_than_or_equal: 'Večje ali enako',
        filter_in_range: 'V obsegu',
        filter_before: 'Pred',
        filter_after: 'Po',
        filter_from: 'Od',
        filter_to: 'Do',
        reload: 'Osveži',
        reset_column_widths: 'Ponastavi širine stolpcev',
        resize_column: 'Spremeni širino stolpca',
        search: 'Iskanje',
        yes: 'Da',
        no: 'Ne',
        list: 'Seznam',
        download: 'Prenesi',
        approve: 'Potrdi',
    },
    nav: {
        tasks: 'Nalogi',
        projects: 'Projekti',
        invoices: 'Fakture',
        submit_request: 'Oddaj zahtevek',
        logout: 'Odjava',
    },
    task: {
        list_open: 'Odprti',
        list_in_confirmation: 'V potrjevanju',
        list_finished: 'Zaključeni',
        status_unassigned: 'Nedodeljen',
        status_open: 'Dodeljen',
        status_in_progress: 'V delu',
        status_waiting: 'Na čakanju',
        status_sent_for_confirmation: 'V potrjevanju',
        status_confirmed: 'Potrjen',
        status_invoiced: 'Fakturiran',
        denied_letter: 'Z',
        title: 'Naslov naloga',
        branch_office: 'Poslovalnica',
        assigned_user: 'Dodeljen',
        added: 'Dodano',
        deadline: 'Rok',
        contact: 'Kontaktna oseba',
        adding_failed: 'Dodajanje zahtevka ni uspelo',
    },
    project: {
        leader: 'Vodja projekta',
        total_tasks: 'Skupno nalogov',
        finished_tasks: 'Zaključeni nalogi',
        completed: 'Zaključeno',
        offer_id: 'Številka ponudbe',
        waiting_for_leader: 'Čakanje na potrditev nosilca projekta',
        waiting_for_client: 'Čakanje na potrditev stranke',
        finished: 'Projekt zaključen',
        denial_reason: 'Razlog zavrnitve:',
    },
    invoice: {
        number_of_tasks: 'Število nalogov',
        invoice_file: 'Faktura',
        times: 'Časi',
        transport: 'Poti',
        transport_names: 'Tipi poti',
        kilometers: 'Kilometri',
        total_time: 'Skupni čas',
        task_ids: 'ID-ji nalogov',
        files: 'Datoteke',
        finished: 'Zaključeno',
        approved_by: 'Potrdil',
        open_printout: 'Odpri izpis',
    },
    client: {
        select: 'Stranka',
        change_failed: 'Menjava ni uspela',
    },
    login: {
        title: 'Prijava',
        subtitle: 'Dobrodošel nazaj, prijavi se v svoj račun.',
        password: 'Geslo',
        forgot_password: 'Pozabljeno geslo?',
        submit: 'Prijava',
        failed: 'Prijava ni uspela',
        language: 'Jezik',
        reset_password: 'Spremeni geslo',
        send_reset_mail: 'Pošlji zahtevo',
        reset_text: 'Mail z povezavo za spremembo gesla in navodili je bil poslan!',
        password_reset_success: 'Geslo je bilo uspešno spremenjeno',
        new_password: 'Novo geslo',
        reset_mail_already_sent: 'E-pošta za spremembo gesla je bila že poslana',
        back_to_login: 'Nazaj na prijavo',
    },
    register: {
        title: 'Registracija',
        last_name: 'Priimek',
        confirm_password: 'Potrdi geslo',
        verification_sent: 'Poslan je bil potrditveni email!',
        failed: 'Registracija ni uspela',
    },
    confirm_mail: {
        title: 'Potrditev Email naslova',
        confirmed: 'Email naslov je bil uspešno potrjen!',
        failed: 'Email naslova ni bilo mogoče potrdit!',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data: 'Neveljavni podatki',
        not_found: 'Ni najdeno',
        on_add: 'Napaka pri dodajanju',
        on_edit: 'Napaka pri urejanju',
        unauthorized: 'Nepooblaščen dostop',
        page_not_found: 'Strani ni mogoče najti',
        back_home: 'Nazaj na začetno stran',
    },
    success: {
        add: 'Uspešno dodano',
        edit: 'Uspešno posodobljeno',
    },
    validation: {
        required: 'To polje je obvezno',
        email: 'Neveljaven e-poštni naslov',
    },
    brand: {
        product_name: 'ITOMS',
    },
    layout: {
        open_menu: 'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark: 'Preklopi na temni način',
    },
}
